<template>
    <el-form :rules="rules" :model="form">
        <el-form-item prop="email">
            <el-input placeholder="请输入邮箱" prefix-icon="el-icon-message" ref="email"
                      v-model.trim="form.email">
            </el-input>
        </el-form-item>
        <el-form-item prop="code">
            <div style="display: flex">
                <div style="width: 40%">
                    <el-input placeholder="请输入验证码" prefix-icon="iconfont icon-yanzhengma1"
                              style="width: 100%;"
                              v-model="form.code">
                    </el-input>
                </div>
                <div style="width: 30%;position: relative;">
                    <img :src="captchaImgUrl"
                         class="imgCaptcha"
                         alt="">
                </div>
                <div style="width: 30%;margin-left: 10px;">
                    看不清？<span style="color:#00a4e0;cursor: pointer;"
                              @click="setCaptchaUrl()">换一张</span>
                </div>
            </div>
        </el-form-item>
        <el-form-item prop="sms" style="margin-top: 5px">
            <div style="display: flex">
                <div style="width: 70%">
                    <el-input placeholder="请输入邮件验证码" prefix-icon="iconfont icon-duanxinfuwu"
                              style="width: 100%;"
                              v-model="form.sms">
                    </el-input>
                </div>
                <div style="width: 30%;">
                    <el-button type="primary" plain @click="sendVerifyCode()"
                               style="width: 100%;margin-left: 5px;margin-right: 5px;">{{ sendBtnText }}
                    </el-button>
                </div>
            </div>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    name: 'SubEmail',
    //type 0/普通发送，1/注册，2/修改邮件，找回密码等等
    props: ['type'],
    created () {
        this.setCaptchaUrl()
    },
    mounted () {
        //设置焦点
        this.$refs.email.focus()
    },
    data () {
        return {
            form: {
                email: '',
                code: '',
                sms: ''
            },
            rules: {
                email: [
                    {
                        required: true,
                        message: '请输入邮箱',
                        trigger: 'blur'
                    }
                ],
                code: [
                    {
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }
                ],
                sms: [
                    {
                        required: true,
                        message: '请输入邮件验证码',
                        trigger: 'blur'
                    }
                ]
            },
            captchaImgUrl: '',
            sendBtnText: '发送验证码',
            sendLimitTime: 0
        }
    },
    methods: {
        setCaptchaUrl: function () {
            this.captchaImgUrl = localStorage.getItem('ServerUrl') + '/api/captcha/get?t=' + Math.random()
        },
        decBtnTime () {
            this.sendLimitTime--
            this.sendBtnText = this.sendLimitTime + 'S'
            if (this.sendLimitTime === 0) {
                this.sendBtnText = '发送验证码'
            } else {
                let that = this
                setTimeout(function () {
                    that.decBtnTime()
                }, 1000)
            }
        },
        sendVerifyCode: function () {
            if (this.sendLimitTime > 0) {
                return
            }
            if (!this.isEmail(this.form.email)) {
                this.showError('请输入正确的邮箱')
                return
            }
            if (this.form.code.length === 0) {
                this.$message.error('请先输入验证码')
                return
            }
            let that = this
            let params = {
                email: this.form.email,
                captcha: this.form.code
            }
            if (this.type) {
                params.type = this.type
            }
            this.$ajax.post('/api/emailverify/send', params).then(function (res) {
                that.sendLimitTime = 60
                that.decBtnTime()
            })
        },
        checkEmail () {
            if (this.isEmpty(this.form.sms)) {
                this.showError('请输入邮件验证码')
                return
            }
            let that = this
            //判断手机验证码是否正确
            this.$ajax.post('/api/emailverify/verify', {
                email: this.form.email,
                code: this.form.sms
            }).then(function (res) {
                that.$emit('emailSuccess', res.data.cert)
            })
        }
    }
}
</script>

<style scoped>
.imgCaptcha {
    border-radius: 3px;
    width: 100%;
    margin-left: 5px;
    margin-right: 5px;
    height: 40px;
    position: absolute;
    top: 0;
    left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/public/sub/SubEmail.vue